import React, { useState } from "react";
import CreateTemplateForm from "./CreateTemplateForm"; // Asegúrate de que la ruta sea correcta
import { api } from "@/contexts/AuthContext";
import { toast } from "sonner";

interface TemplateCreatorModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreated?: (newTemplateId?: string) => void;
  initialValues?: {
    name?: string;
    category?: string;  // "Utilidad" | "Marketing"
    language?: string;  // "es" | "en"
  };
}

const TemplateCreatorModal: React.FC<TemplateCreatorModalProps> = ({
  isOpen,
  onClose,
  onCreated,
  initialValues,
}) => {
  const [newTemplate, setNewTemplate] = useState({
    name: initialValues?.name || "",
    template: "",
    category: initialValues?.category || "Utilidad",
    language: initialValues?.language || "es",
  });

  // Reset to initialValues each time the modal opens
  React.useEffect(() => {
    if (isOpen) {
      setNewTemplate({
        name: initialValues?.name || "",
        template: "",
        category: initialValues?.category || "Utilidad",
        language: initialValues?.language || "es",
      });
    }
  }, [isOpen]);

  const extractVariables = (template: string): string[] => {
    const re = /\{\{\s*([^}]+?)\s*\}\}/g;
    const vars: string[] = [];
    let m: RegExpExecArray | null;
    while ((m = re.exec(template)) !== null) vars.push(m[1].trim());
    return vars;
  };

  const handleCreateTemplate = async (payloadFromForm?: any) => {
    try {
      // If _skipInsert is true, the template was already created by /whatsapp/templates/create
      // We just need to notify the parent to refresh the list
      if (payloadFromForm?._skipInsert) {
        onCreated?.(payloadFromForm.id); // Send ID back if available
        onClose();
        return;
      }

      // Legacy path: create template via /templates (without Meta)
      const payload = {
        name: payloadFromForm?.name ?? newTemplate.name ?? "Sin nombre",
        template: payloadFromForm?.template ?? newTemplate.template ?? "",
        category: payloadFromForm?.category ?? newTemplate.category ?? "General",
        variables: payloadFromForm?.variables ?? extractVariables(newTemplate.template),
        language: payloadFromForm?.language ?? newTemplate.language ?? "es",
      };

      const res = await api.post('/templates', payload);
      const created = res.data;
      const newId = created?.id ?? created?._id ?? String(created);
      toast.success("Plantilla creada exitosamente");
      onCreated?.(newId);
      onClose();
    } catch (err) {
      console.error("Error creando plantilla:", err);
      toast.error("No se pudo crear la plantilla");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />
      <div className="relative w-full max-w-4xl mx-4 z-10">
        <div className="overflow-auto" style={{ maxHeight: "85vh" }}>
          <div className="p-4">
            <CreateTemplateForm
              newTemplate={newTemplate}
              setNewTemplate={setNewTemplate}
              extractVariables={extractVariables}
              handleCreateTemplate={handleCreateTemplate}
              setShowCreateForm={onClose}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateCreatorModal;